import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiserviceService {
  menuList = new BehaviorSubject([]);
  constructor(private http: HttpClient) { }
  getStaticPageByName(data: any) {
    return this.http.get(`https://uatapi.luminousindia.com/customer/api/StaticPageData/GetStaticPageDataByPageName?pageName=${data.pageName}`, data)
      .pipe(catchError(e => e))
  }
  getHomePageData() {
    let url = 'https://uatapi.luminousindia.com/customer/api/LandingPage/GetCustomerBrandLandingPage';
    // return this.http.get(https://uatapi.luminousindia.com/customer/api/LandingPage/GetCustomerBrandLandingPage).pipe(catchError(e => e));
    return url
  }
}
